export const AVR_STATUS = Object.freeze({
  CREATED: "CREATED",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
  SIGNED: "SIGNED",
});

export const AVR_TABLE_GRID_TEMPLATE_COLUMNS =
  "80px 1fr 2fr 110px 1fr 220px 1fr";

export const avrTableColumns = [
  { name: "ids", label: "ID", align: "center" },
  { name: "service_name", label: "Сервис", align: "left" },
  { name: "avr_name", label: "Наименование документа", align: "left" },
  { name: "avr_sum", label: "Сумма", align: "right" },
  { name: "status_name", label: "Статус", align: "left" },
  { name: "actions", label: "Действия", align: "center" },
  { name: "status_1c", label: "Статус в 1С", align: "left" },
];
